<template>
  <v-dialog v-model="mostrar" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Actualizar género</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="generoLocal"
                :items="generos"
                label="Género:"
                :disabled="loading"
                item-value="value"
                item-text="text"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="primary"
          outlined
          small
          :disabled="loading"
          @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="primary"
          dark
          small
          :loading="loading"
          @click="actualizarGenero()"
          >Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { actualizarGeneroService } from "./usuarios.service";

export default {
  name: "modificarGenero",
  props: ["mostrar", "idUsuario", "genero"],
  data: () => ({
    loading: false,
    generoLocal: '',
    generos: [{ text: 'Mujer',value: 'M' },{ text: 'Hombre',value: 'H' }],
  }),
  created() {
    this.generoLocal = this.genero;
  },
  methods: {
    async actualizarGenero() {
      try {
        this.loading = true;
        const sendData = {
          idUsuario: this.idUsuario,
          genero: this.generoLocal,
        };
        const serverResponse = await actualizarGeneroService(sendData);
        this.loading = false;

        if (!serverResponse.ok) {
          throw new Error(serverResponse.mensaje);
        } else {
          const emitData = {
            idUsuario: this.idUsuario,
            genero: this.generoLocal
          };
          this.$emit("generoModificado", emitData);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    }
  },
}
</script>